export default "__VITE_ASSET__XZ2kibTe__"